import {useCallback, useState} from 'react';
import {Session, useAuthStore} from '../../common/stores/useAuthStore';
import DashLogo from '../../assets/svgs/LogoLongText.svg';
import {LoginForm} from '../forms/LoginForm';
import {SignInUserRequest} from '../../generated/models/SignInUserRequest';
import {apiRequest} from '../../common/services/api';
import {signInEndpoint} from '../../common/constants/endpoints';
import {Navigate} from 'react-router-dom';
import routes from '../routes/routes';
import {useUiStore} from '../../common/stores/useUiStore';

export const SignInScreen = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const {setSession, session} = useAuthStore(state => state);
  const setIsLoading = useUiStore(state => state.setIsLoading);

  const onLogin = useCallback(
    async (e: React.FormEvent) => {
      e.preventDefault();
      setError(null);
      setIsLoading(true);
      let failure: unknown = null;
      const response = await apiRequest<Session, SignInUserRequest>(
        {
          endpoint: signInEndpoint,
          method: 'POST',
          body: {
            email: email.trim(),
            password,
          },
        },
        {
          shouldPrintLogs: true,
          onError: signInError => {
            failure = signInError;
          },
        },
      );
      setIsLoading(false);
      if (!response?.data) {
        // Wrong credentials come back as a validation error naming
        // invalid_credentials; anything else is the server or the network.
        const text = failure instanceof Error ? failure.message : '';
        setError(
          /invalid_credentials|HTTP error status: 40[01]/.test(text)
            ? 'The email or password is incorrect.'
            : 'Could not sign in right now. Check your connection and try again.',
        );
        return;
      }
      setSession(response.data);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [email, password],
  );

  if (session) {
    return <Navigate to={routes.activities} replace />;
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#1D1D1F',
        minHeight: '100vh',
        width: '100vw',
        padding: 20,
        boxSizing: 'border-box',
      }}>
      <div style={{textAlign: 'center', marginBottom: 20}}>
        <img src={DashLogo} alt="Logo" style={{marginBottom: 20}} />
        <h1 style={{color: '#FFFFFF', margin: 0}}>Please Sign In</h1>
      </div>

      <div style={{width: '100%', maxWidth: 400}}>
        <LoginForm
          email={email}
          setEmail={setEmail}
          password={password}
          setPassword={setPassword}
          onSubmit={onLogin}
          error={error}
        />
      </div>
    </div>
  );
};
